"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./dtos/accommodationPriceHistoryDto");
class AccommodationPriceHistory {
}
exports.AccommodationPriceHistory = AccommodationPriceHistory;
